import React from "react";
import { useNavigate } from "react-router-dom";

export default function ContactPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 relative">
      {/* Top Back Button */}

      <div className="max-w-3xl mx-auto mt-20 text-center">
        <h1 className="text-4xl font-bold mb-6">Contact Us</h1>
        <p className="text-lg leading-relaxed">
          For any queries, please write to us on{" "}
          <a
            href="mailto:a@aicahealth.com"
            className="underline hover:text-yellow-200 transition"
          >
            a@aicahealth.com
          </a>{" "}
          or call us on AICA Helpline:{" "}
          <a
            href="tel:+919821286111"
            className="underline hover:text-yellow-200 transition"
          >
            +91 98212 86111
          </a>
        </p>
      </div>

      {/* Bottom Back Button */}
      <div className="flex justify-center mt-10">
        <button
          onClick={() => navigate("/")}
          className="bg-white text-teal-600 px-6 py-2 rounded-full shadow hover:bg-gray-100 transition"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
